import { render, staticRenderFns } from "./scale.vue?vue&type=template&id=7bb3c7bf&scoped=true&"
import script from "./scale.vue?vue&type=script&lang=js&"
export * from "./scale.vue?vue&type=script&lang=js&"
import style0 from "./scale.vue?vue&type=style&index=0&id=7bb3c7bf&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb3c7bf",
  null
  
)

export default component.exports